import React, { useState } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Mail, Plus, Minus } from 'lucide-react';
export function ContactPage() {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    company: '',
    subject: '',
    message: ''
  });
  const handleChange = e => {
    const {
      id,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [id]: value
    }));
  };
  const handleSubmit = e => {
    e.preventDefault();
    // Log form data to console
    console.log('Contact form submitted:', formData);
    // In a real implementation, this would send data to a backend service
    // that would forward the information to ramzad@rawfounders.com
    alert('Thank you for your message! Your inquiry has been sent to ramzad@rawfounders.com. We will get back to you soon.');
    // Reset form
    setFormData({
      firstName: '',
      lastName: '',
      email: '',
      company: '',
      subject: '',
      message: ''
    });
  };
  return <div className="flex flex-col min-h-screen w-full" data-id="element-582">
      <Header data-id="element-583" />
      <main className="flex-grow" data-id="element-584">
        {/* Hero Section */}
        <div className="bg-black text-white py-16 md:py-24" data-id="element-585">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-586">
            <div className="text-center" data-id="element-587">
              <h1 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-588">
                Contact Us
              </h1>
              <p className="text-xl md:text-2xl max-w-3xl mx-auto text-gray-300" data-id="element-589">
                Have questions about Agentter.ai? Our team is here to help.
              </p>
            </div>
          </div>
        </div>
        {/* Contact Form & Info */}
        <div className="py-16 md:py-24 bg-white" data-id="element-590">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-591">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-592">
              {/* Contact Form */}
              <div data-id="element-593">
                <h2 className="text-3xl font-bold mb-6" data-id="element-594">Get in Touch</h2>
                <p className="text-lg text-gray-600 mb-8" data-id="element-595">
                  Fill out the form below and we'll get back to you as soon as
                  possible.
                </p>
                <form onSubmit={handleSubmit} data-id="element-596">
                  <div className="space-y-6" data-id="element-597">
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-598">
                      <div data-id="element-599">
                        <label htmlFor="firstName" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-600">
                          First Name
                        </label>
                        <input type="text" id="firstName" value={formData.firstName} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:outline-none" required data-id="element-601" />
                      </div>
                      <div data-id="element-602">
                        <label htmlFor="lastName" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-603">
                          Last Name
                        </label>
                        <input type="text" id="lastName" value={formData.lastName} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:outline-none" required data-id="element-604" />
                      </div>
                    </div>
                    <div data-id="element-605">
                      <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-606">
                        Email Address
                      </label>
                      <input type="email" id="email" value={formData.email} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:outline-none" required data-id="element-607" />
                    </div>
                    <div data-id="element-608">
                      <label htmlFor="company" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-609">
                        Company Name
                      </label>
                      <input type="text" id="company" value={formData.company} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:outline-none" data-id="element-610" />
                    </div>
                    <div data-id="element-611">
                      <label htmlFor="subject" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-612">
                        Subject
                      </label>
                      <select id="subject" value={formData.subject} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:outline-none" required data-id="element-613">
                        <option value="" data-id="element-614">Select a subject</option>
                        <option value="sales" data-id="element-615">Sales Inquiry</option>
                        <option value="support" data-id="element-616">Technical Support</option>
                        <option value="partnership" data-id="element-617">
                          Partnership Opportunity
                        </option>
                        <option value="press" data-id="element-618">Press Inquiry</option>
                        <option value="other" data-id="element-619">Other</option>
                      </select>
                    </div>
                    <div data-id="element-620">
                      <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-621">
                        Message
                      </label>
                      <textarea id="message" value={formData.message} onChange={handleChange} rows={5} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:outline-none" required data-id="element-622"></textarea>
                    </div>
                    <div data-id="element-623">
                      <button type="submit" className="w-full bg-black text-white py-3 rounded-lg font-medium hover:bg-gray-800 transition-colors" data-id="element-624">
                        Send Message
                      </button>
                    </div>
                  </div>
                </form>
              </div>
              {/* Email Contact Info */}
              <div data-id="element-625">
                <div className="bg-gray-50 p-8 rounded-lg" data-id="element-626">
                  <h3 className="text-2xl font-bold mb-6" data-id="element-627">
                    Contact Information
                  </h3>
                  <div className="space-y-6" data-id="element-628">
                    <ContactInfo icon={<Mail data-id="element-630" />} title="Email Us" details={[{
                    label: 'General Inquiries',
                    value: 'info@agentter.ai'
                  }, {
                    label: 'Support',
                    value: 'support@agentter.ai'
                  }, {
                    label: 'Sales',
                    value: 'sales@agentter.ai'
                  }]} data-id="element-629" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* FAQ Section */}
        <div className="py-16 md:py-24 bg-gray-50" data-id="element-631">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-632">
            <div className="text-center mb-16" data-id="element-633">
              <h2 className="text-3xl font-bold mb-4" data-id="element-634">
                Frequently Asked Questions
              </h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-635">
                Find quick answers to common questions about Agentter.ai.
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-636">
              <FAQItem question="What is Agentter.ai?" answer="Agentter.ai is a platform that allows businesses to create custom AI agents that automate workflows and tasks without requiring any coding knowledge." data-id="element-637" />
              <FAQItem question="Do I need technical knowledge to use Agentter.ai?" answer="No, our platform is designed to be user-friendly. You can create AI agents by describing what you need in plain English." data-id="element-638" />
              <FAQItem question="How quickly can I get started?" answer="You can sign up and create your first AI agent in minutes. Our onboarding process guides you through connecting your software and defining your agent's tasks." data-id="element-639" />
              <FAQItem question="What software does Agentter.ai integrate with?" answer="We integrate with hundreds of popular business tools including Salesforce, Slack, Gmail, Shopify, Zendesk, and many more." data-id="element-640" />
              <FAQItem question="Is my data secure with Agentter.ai?" answer="Yes, we take security seriously. We use enterprise-grade encryption and follow best practices for data protection. We're also SOC 2 compliant." data-id="element-641" />
              <FAQItem question="What is the pricing model?" answer="We offer tiered pricing based on the number of agents and tasks. We have plans suitable for small businesses to enterprise organizations. Check our pricing page for details." data-id="element-642" />
            </div>
          </div>
        </div>
      </main>
      <Footer data-id="element-643" />
    </div>;
}
function ContactInfo({
  icon,
  title,
  details
}) {
  return <div className="flex" data-id="element-644">
      <div className="mr-4 mt-1" data-id="element-645">
        <div className="bg-black text-white p-2 rounded-full" data-id="element-646">{icon}</div>
      </div>
      <div data-id="element-647">
        <h4 className="text-lg font-semibold mb-2" data-id="element-648">{title}</h4>
        <ul className="space-y-2" data-id="element-649">
          {details.map((detail, index) => <li key={index} data-id="element-650">
              <span className="text-gray-600" data-id="element-651">{detail.label}: </span>
              <span className="font-medium" data-id="element-652">{detail.value}</span>
            </li>)}
        </ul>
      </div>
    </div>;
}
function FAQItem({
  question,
  answer
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border border-gray-200 rounded-lg overflow-hidden mb-4" data-id="element-653">
      <button onClick={() => setIsOpen(!isOpen)} className="flex justify-between items-center w-full p-4 text-left bg-white hover:bg-gray-50 transition-colors" data-id="element-654">
        <h3 className="text-lg font-semibold" data-id="element-655">{question}</h3>
        <div className="flex-shrink-0 ml-2" data-id="element-656">
          {isOpen ? <Minus className="text-black" size={20} data-id="element-657" /> : <Plus className="text-black" size={20} data-id="element-658" />}
        </div>
      </button>
      <div className={`overflow-hidden transition-all duration-300 ${isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-659">
        <p className="p-4 pt-0 text-gray-600 border-t border-gray-100" data-id="element-660">
          {answer}
        </p>
      </div>
    </div>;
}